/* =====================================================================
 * Spinner — 로딩 인디케이터
 * ===================================================================== */

import React from 'react';
import styled, { keyframes } from 'styled-components';

/* --- Dots Spinner (ChatGPT style) --- */
const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
`;

const DotsWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const Dot = styled.span<{ $delay: number }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.textMuted};
  animation: ${bounce} 1.4s ease-in-out ${({ $delay }) => $delay}s infinite both;
`;

export const DotsSpinner: React.FC = () => (
  <DotsWrapper>
    <Dot $delay={0} />
    <Dot $delay={0.16} />
    <Dot $delay={0.32} />
  </DotsWrapper>
);

/* --- Ring Spinner --- */
const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Ring = styled.div<{ $size: number; $color?: string }>`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme, $color }) => $color || theme.colors.accent};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

export const RingSpinner: React.FC<{ size?: number; color?: string }> = ({
  size = 20,
  color,
}) => <Ring $size={size} $color={color} />;

/* --- Typing Cursor --- */
const blinkAnim = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const Cursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 1.1em;
  background: ${({ theme }) => theme.colors.accent};
  margin-left: 2px;
  vertical-align: text-bottom;
  animation: ${blinkAnim} 1s step-end infinite;
`;

export const TypingCursor: React.FC = () => <Cursor />;

